import React from "react";
import {
  Box,
  Typography,
  Container,
} from "@mui/material";
import { PlayCircleFilled } from "@mui/icons-material";

const TravelReels = () => {
  const videoUrls = [
    "https://www.youtube.com/shorts/SU3w-P5ohfQ",
    "https://www.youtube.com/shorts/DSxfSGYk-6c",
    "https://www.youtube.com/shorts/F12tjWjeDUY",
    "https://www.youtube.com/shorts/a9nljZbyJSk",
    "https://www.youtube.com/shorts/XJKFOFj3BxE",
  ];

  const getYouTubeId = (url) => {
    const match = url.match(/shorts\/([^?]+)/);
    return match ? match[1] : null;
  };

  return (
    <Box sx={{ bgcolor: "#fff", py: { xs: 5, md: 8 } }}>
      {/* Header */}
      <Container maxWidth={false} sx={{ px: { xs: 2, md: 6 } }}>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <PlayCircleFilled sx={{ color: "#ff0000", fontSize: 34 }} />
            <Typography variant="h4" fontWeight={800}>
              Travel Shorts
            </Typography>
          </Box>
          <Typography color="text.secondary">
            Catch a glimpse of the adventure in seconds.
          </Typography>
        </Box>
      </Container>

      {/* FULL WIDTH REELS */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(2, 1fr)",
            sm: "repeat(3, 1fr)",
            md: "repeat(5, 1fr)", // INLINE on PC
          },
          gap: { xs: 1.5, md: 2.5 },
          px: { xs: 2, md: 6 },
        }}
      >
        {videoUrls.map((url, index) => {
          const videoId = getYouTubeId(url);
          if (!videoId) return null;

          return (
            <Box
              key={index}
              onClick={() =>
                window.open(
                  `https://www.youtube.com/shorts/${videoId}`,
                  "_blank"
                )
              }
              sx={{
                position: "relative",
                width: "100%",
                paddingTop: "177%", // 9:16
                borderRadius: "18px",
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
                transition: "0.35s",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 20px 45px rgba(0,0,0,0.2)",
                },
              }}
            >
              {/* Thumbnail */}
              <Box
                component="img"
                src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                alt="Travel Reel"
                sx={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {/* Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.5), transparent)",
                }}
              >
                <PlayCircleFilled
                  sx={{ fontSize: 64, color: "#fff", opacity: 0.9 }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default TravelReels;
